/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfPtwCommentDto
 */
export interface ODataPostProcessedResultsOfPtwCommentDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfPtwCommentDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof ODataPostProcessedResultsOfPtwCommentDto
     */
    value?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfPtwCommentDto
     */
    $type?: ODataPostProcessedResultsOfPtwCommentDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfPtwCommentDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfPtwCommentDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedCommonDtoCommentsPtwCommentDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.Comments.PtwCommentDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfPtwCommentDtoTypeEnum = typeof ODataPostProcessedResultsOfPtwCommentDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfPtwCommentDtoTypeEnum];


/**
 * Check if a given object implements the ODataPostProcessedResultsOfPtwCommentDto interface.
 */
export function instanceOfODataPostProcessedResultsOfPtwCommentDto(value?: unknown): value is ODataPostProcessedResultsOfPtwCommentDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfPtwCommentDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfPtwCommentDtoFromJSON(json: any): ODataPostProcessedResultsOfPtwCommentDto {
    return ODataPostProcessedResultsOfPtwCommentDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfPtwCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfPtwCommentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(PtwCommentDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'odataCount': !exists(json, '@odata.count') ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfPtwCommentDtoToJSON(value?: ODataPostProcessedResultsOfPtwCommentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value.totalCount,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(PtwCommentDtoToJSON)),
        '$type': value.$type,
        '@odata.count': value.odataCount,
    });
}

